import type {
  Block,
  CalloutData,
} from "../../../../models/ManualAuthoring";

import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import SimpleInlineTextEditor from "../editor/SimpleInlineTextEditor";
import "./warning.css";

export default function WarningEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as CalloutData;

  return (
    <div className="pdf-block pdf-warning pdf-warning--editing">
      <div className="pdf-warning__header">
        <span className="pdf-warning__symbol">⚠</span>
        <span className="pdf-warning__label">WARNING</span>
      </div>

      <div className="pdf-warning__content">
        <SimpleInlineTextEditor
          textParts={data.textParts || []}
          onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
          onDone={onDone}
        />
      </div>
    </div>
  );
}
